// extracted by mini-css-extract-plugin
module.exports = {"style":"fixedheader-module--style--meXW6","styleGreen":"fixedheader-module--styleGreen--fb41x"};